const TICKET_SCROLL_OFFSET = 120;

/**
 * Tickets button for an "Andere dagen en tijden" row: renders the LVP widget
 * for that showing inline below the row, closing any other open ticket
 * container (including the main #orderTicketsContainer) first.
 * Falls back to following the href when the widget engine is not available.
 */
export default class ShowingTickets {
	constructor(element) {
		this.element = element;
		this.containerId = element.dataset.containerId;
		this.rendered = false;
		this.addEventListeners();
	}

	get container() {
		return document.getElementById(this.containerId);
	}

	addEventListeners() {
		this.element.addEventListener('click', (event) => {
			if (typeof window.tww !== 'function' || !this.container) {
				return; // no widget engine: follow the link to the showing's own page
			}
			event.preventDefault();
			if (this.container.classList.contains('hide')) {
				this.show();
			} else {
				this.hide();
			}
		});

		// close this widget when another one opens (main button or other showing)
		window.addEventListener('tickets:show', (event) => {
			if (event && event.detail && event.detail.containerId !== this.containerId) {
				this.hide();
			}
		});
	}

	show() {
		const container = this.container;

		// the main container's own script ignores tickets:show while it is hidden
		document.querySelectorAll('#orderTicketsContainer').forEach((el) => el.classList.add('hide'));
		window.dispatchEvent(new CustomEvent('tickets:show', { detail: { containerId: this.containerId } }));

		container.classList.remove('hide');
		this.element.setAttribute('aria-expanded', 'true');

		if (!this.rendered) {
			this.rendered = true;
			window.tww('SetTheme', 'CulturaEde');
			window.tww('Activity', parseInt(this.element.dataset.ticketId, 10), this.containerId, this.element.dataset.flow, this.element.dataset.cartUrl);
		} else {
			const iframe = container.querySelector('iframe');
			if (iframe && iframe.iFrameResizer && typeof iframe.iFrameResizer.resize === 'function') {
				iframe.iFrameResizer.resize();
			}
			window.dispatchEvent(new Event('resize'));
		}

		window.scrollTo({
			top: Math.max(container.getBoundingClientRect().top + window.scrollY - TICKET_SCROLL_OFFSET, 0),
			behavior: 'smooth',
		});
	}

	hide() {
		if (this.container) {
			this.container.classList.add('hide');
		}
		this.element.setAttribute('aria-expanded', 'false');
	}
}
